import React, { CSSProperties, VFC } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { MenuItemInterface } from './Menu';
import { SmallMenuItemsSC } from './SmallMenu.styled';
import { useTranslation } from 'utils/localization';
import A from 'components/layouts/A';
import Icon from 'components/icon/Icon';

const SmallMenuBadgeSC = styled.span`
    margin-left: auto;
    flex: 0 0 auto;
    min-width: 18px;
    padding: 1px 7px;
    border-radius: 999px;
    font-size: 10.5px;
    font-weight: 700;
    line-height: 1.6;
    text-align: center;
    background: rgba(255, 255, 255, 0.16);
    color: #fff;
`;

interface Props {
    items: MenuItemInterface[];
    mainItemIcon: any;
    mainItemIconStyle?: CSSProperties;
    text: string;
    activeItem?: MenuItemInterface;
}

const SmallMenuItems: VFC<Props> = ({
    items,
    mainItemIcon,
    mainItemIconStyle,
    text,
    activeItem,
}) => {
    const { t } = useTranslation();

    return (
        <SmallMenuItemsSC>
            <div className="menuCategory">
                {mainItemIcon && (
                    <Icon
                        icon={mainItemIcon}
                        style={mainItemIconStyle}
                        className="icon"
                    />
                )}
                {t(text)}
            </div>
            {items.map(
                (
                    { text, icon, iconStyle, link, badge, badgeTitle },
                    itemKey
                ) => (
                    <div className="menuItem" key={itemKey}>
                        {icon && (
                            <Icon
                                icon={icon}
                                style={iconStyle}
                                className="icon"
                            />
                        )}
                        <A
                            href={link}
                            className={classNames({
                                active:
                                    !!activeItem &&
                                    !!link &&
                                    link === activeItem.link,
                            })}
                        >
                            <>{t(text)}</>
                        </A>
                        {!!badge && badge > 0 && (
                            <SmallMenuBadgeSC
                                title={
                                    badgeTitle
                                        ? t(badgeTitle, { count: badge })
                                        : undefined
                                }
                            >
                                {badge}
                            </SmallMenuBadgeSC>
                        )}
                    </div>
                )
            )}
        </SmallMenuItemsSC>
    );
};

export default SmallMenuItems;
